import {
  Transforms
} from 'slate';

import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    type: types.SIGNATURE_PANEL,
    children: [{ text: '' }],
  };

  node.properties = {
    ...node.properties,
    ...options
  };

  return node;

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Transforms.insertNodes(editor, buildNode(options), { at: targetNodePath });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}